import { ChatPanel } from "llmasaservice-ui";
import { useUser } from "../contexts/useUser";
import "../../node_modules/llmasaservice-ui/dist/index.css";
import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
} from "@mui/material";
import {
  materialDark,
  materialLight,
} from "react-syntax-highlighter/dist/esm/styles/prism";
import { useQuery } from "@tanstack/react-query";
import { fetchLLMGroups } from "../dataaccess/fetchLLMGroups";
import { useState } from "react";
import { Checkbox } from "@mui/material";
import { LLMEmailCaptureMode } from "../API";
import { Form } from "react-router-dom";

const ChatTest: React.FC = () => {
  const { project } = useUser();
  const [selectedGroup, setSelectedGroup] = useState<string>("");
  const [createConversation, setCreateConversation] = useState<boolean>(false);
  const [customerEmailCaptureMode, setCustomerEmailCaptureMode] =
    useState<LLMEmailCaptureMode>(LLMEmailCaptureMode.HIDE);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["groups"],
    queryFn: () => fetchLLMGroups(project?.id ?? ""),
    enabled: project?.id && project?.id.length > 0 ? true : false,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error...</div>;
  }

  const groups = data?.data?.groupsByProjectId?.items ?? [];

  let publicAPIUrl = "https://api.llmasaservice.io";

  let url = "https://chat.llmasaservice.io/";
  // if the url is localhost or dev.llmasaservice.io, we are in development mode and we should use the dev endpoint
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "dev.llmasaservice.io"
  ) {
    url = "https://chat.llmasaservice.io/dev";
    publicAPIUrl = "https://8ftw8droff.execute-api.us-east-1.amazonaws.com/dev";
  }

  const THEME_KEY = "_llmasaservice_theme";
  const userThemePreference = localStorage.getItem(THEME_KEY) || "dark";

  return (
    <Box margin={2}>
      <Paper
        elevation={3}
        style={{ borderRadius: 3, border: "1px solid #444" }}
      >
        <Box padding={2} margin={1}>
          <FormControl>
            <InputLabel id="group-select-label">Service Group</InputLabel>
            <Select
              labelId="group-select-label"
              value={selectedGroup}
              onChange={(e) => setSelectedGroup(e.target.value)}
              label="Service Group"
              style={{ width: "300px" }}
              size="small"
            >
              <MenuItem value="">
                <em>Default</em>
              </MenuItem>
              {groups.map((group: any) => (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ml:2}}>
          <FormControlLabel
            control={
              <Checkbox
                checked={createConversation}
                onChange={(e) => setCreateConversation(e.target.checked)}
              />
            }
            label="Save conversation?"
          />
          </FormControl>

          <FormControl>
            <InputLabel id="email-capture-label">Email capture mode</InputLabel>
            <Select
              labelId="email-capture-label"
              value={customerEmailCaptureMode}
              onChange={(e: any) => setCustomerEmailCaptureMode(e.target.value)}
              label="Email capture mode"
              style={{ width: "300px" }}
              size="small"
            >
              <MenuItem value={LLMEmailCaptureMode.HIDE}>Hide</MenuItem>
              <MenuItem value={LLMEmailCaptureMode.OPTIONAL}>Optional</MenuItem>
              <MenuItem value={LLMEmailCaptureMode.REQUIRED}>Required</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Paper>

      <ChatPanel
        project_id={project?.id ?? ""}
        initialMessage={`Hello, use this chat to test the LLM services defined in this project. Tokens are used from the customer called ${project?.name}.`}
        theme={userThemePreference === "light" ? "light" : "dark"}
        height="80vh"
        width="100%"
        url={url}
        hideInitialPrompt={false}
        service={selectedGroup}
        createConversationOnFirstChat={createConversation}
        customerEmailCaptureMode={customerEmailCaptureMode}
      />
    </Box>
  );
};

export default ChatTest;
